module.exports = __webpack_public_path__ + "img/c01_unitcaravan_Normal_ua.1c8c0d6e.webp";